var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { CalendarEventCardSecondOption } from "../CalendarEventCardSecondOption";
import { Tabs } from "../../Tabs";
import events from "../../../mocks/calendar/events.json";
import { months } from "../../../mocks/month";
import moment from "moment";
import styled from "styled-components";
import { Heading } from "grommet";
import Image from "../../../images/logo.png";
var StyledHeading = styled(Heading)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  margin-bottom: 2.5rem;\n  text-transform: uppercase;\n",
    ]))
);
export var CalendarItem = function CalendarItem() {
  var _React$useState = React.useState(months[0]),
    selectedMonth = _React$useState[0],
    setSelectedMonth = _React$useState[1];

  var filteredMonths = months.filter(function (month) {
    var hasEvents = events.some(function (event) {
      return moment(event.start, "DD.MM.YYYY").isSame(month.value, "M");
    });
    return hasEvents || month.value === null;
  });
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(StyledHeading, {
      level: 3,
      fill: true,
    }),
    /*#__PURE__*/ React.createElement(Tabs, {
      onUpdate: function onUpdate(id) {
        return setSelectedMonth(filteredMonths[id]);
      },
      tabs: filteredMonths,
    }),
    /*#__PURE__*/ React.createElement(CalendarEventCardSecondOption, {
      events: events,
      image: Image,
      selectedMonth: selectedMonth,
    })
  );
};
